import React from 'react';

// tabs: [{ value, label, icon, count }]
export function Tabs({ tabs, value, onChange, className = '' }) {
  return (
    <div className={`ss-tabs ${className}`} role="tablist">
      {tabs.map(({ value: v, label, icon: Icon, count, tour }) => (
        <button
          key={v}
          type="button"
          role="tab"
          aria-selected={value === v}
          className={`ss-tab ${value === v ? 'ss-tab--active' : ''}`}
          onClick={() => onChange(v)}
          data-tour={tour}
        >
          {Icon && <Icon size={16} strokeWidth={2.2} aria-hidden="true" />}
          <span>{label}</span>
          {count != null && <span className="ss-tab__count">{count}</span>}
        </button>
      ))}
    </div>
  );
}
